import { createTheme, PaletteOptions } from "@mui/material";
import { TypographyOptions } from "@mui/material/styles/createTypography";
import type {} from "@mui/x-data-grid/themeAugmentation";

export const lightPalette: PaletteOptions = {
    text: {
        primary: "#424242",
        secondary: "#757575",
        disabled: "#7F7F7F",
    },
    primary: {
        main: "#09AE5F",
        dark: "#007C3D",
        light: "#44BA76",
        contrastText: "#FFFFFF",
    },
    secondary: {
        main: "#07AFF8",
        dark: "#008ED5",
        light: "#52C8F9",
        contrastText: "#FFFFFF",
    },
    error: {
        main: "#ED3300",
        dark: "#9e2200",
        light: "#ff5729",
        contrastText: "#ffdbd1",
    },
    success: {
        main: "#007C3D",
        contrastText: "#FFFFFF",
    },
    background: {
        default: "#ECEEF2",
        paper: "#FFFFFF",
    },
};

export const darkPalette: PaletteOptions = {
    text: {
        primary: "#E6E6E5",
        secondary: "#E6E6E5",
        disabled: "#A5A5A5",
    },
    primary: {
        main: "#44BA76",
        dark: "#09AE5F",
        light: "#6AC68E",
        contrastText: "#FFFFFF",
    },
    secondary: {
        main: "#07AFF8",
        dark: "#008ED5",
        light: "#52C8F9",
        contrastText: "#000000",
    },
    success: {
        main: "#007C3D",
        contrastText: "#FFFFFF",
    },
    error: {
        main: "#c22a00",
        dark: "#9e2200",
        light: "#ff5729",
        contrastText: "#ffdbd1",
    },
    background: {
        default: "#252F37",
        paper: "#171d22",
    },
};

const typography: TypographyOptions = {
    h1: {
        fontSize: "3.25rem",
        // fontFamily: "Utara, Helvetica, Arial, sans-serif",
        lineHeight: "4.5rem",
    },
    h2: {
        fontSize: "2.625rem",
        // fontFamily: "Utara, Helvetica, Arial, sans-serif",
        fontWeight: 400,
        lineHeight: "3.5rem",
    },
    h3: {
        fontSize: "2.125rem",
        // fontFamily: "Utara, Helvetica, Arial, sans-serif",
        lineHeight: "3rem",
    },
    h4: {
        fontSize: "1.6875rem",
        // fontFamily: "Utara, Helvetica, Arial, sans-serif",
        fontWeight: 500,
        lineHeight: "2.5rem",
    },
    h5: {
        // fontFamily: "Utara, Helvetica, Arial, sans-serif",
        lineHeight: "2rem",
    },
    h6: {
        fontSize: "1.1875rem",
        // fontFamily: "Utara, Helvetica, Arial, sans-serif",
        lineHeight: "1.5rem",
    },
    body1: {
        fontSize: "1rem",
        lineHeight: "1.5rem",
    },
    body2: {
        fontSize: "0.875rem",
        lineHeight: "1rem",
    },
};

export const theme = createTheme({
    colorSchemes: {
        light: { palette: lightPalette },
        dark: { palette: darkPalette },
    },
    typography,
    components: {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    "--DataGrid-pinnedBackground": "rgba(0,0,0,0)",
                    "--DataGrid-containerBackground": "rgba(0,0,0,0)",
                },
            },
        },
        MuiButtonBase: {
            defaultProps: {},
        },
        MuiTextField: {
            defaultProps: {
                variant: "filled",
                size: "small",
            },
            styleOverrides: {
                root: {
                    "& .MuiFilledInput-root": {
                        borderRadius: "4px",
                    },
                    "& .MuiFormLabel-root.Mui-error": {
                        color: "currentColor",
                    },
                    "& .MuiFilledInput-underline:before": {
                        borderBottom: "none",
                    },
                    "& .MuiFilledInput-underline:after": {
                        borderBottom: "none",
                    },
                    "& .MuiFilledInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottom: "none",
                    },
                    "& .MuiFilledInput-underline.Mui-disabled:before": {
                        borderBottom: "none",
                    },
                },
            },
        },
    },
});
